module.exports = __webpack_public_path__ + "static/media/Pennsbury_Manor_Museum_Morrisville_PA_diorama_background_installed.d5a7deea.webp";